import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContactTypes, createContactType /* , deleteContactType */ } from '../../redux/contactTypeStore/action';
import { useMemo } from 'react';

export function ContactTypeManager() {
  const dispatch = useDispatch();
  const { data: types, status } = useSelector((s) => s.contactType);
  const auth = useSelector((s) => s.auth);
  const [name, setName] = useState('');
  const [color, setColor] = useState('#FFFFFF');

  useEffect(() => {
    if (status === 'idle') dispatch(fetchContactTypes());
  }, [dispatch, status]);

  const currentUserId = useMemo(() => {
    const payload = auth?.userData || {};
    const token = localStorage.getItem('accessToken');
    const decodeJwt = (t) => {
      try { const p = JSON.parse(atob(t.split('.')[1])); return p; } catch { return null; }
    };
    const tokenUser = token ? decodeJwt(token) : null;
    return (
      payload?.user?.id || payload?.user?._id || payload?.userId || payload?._id || payload?.userId || tokenUser?.userId || null
    );
  }, [auth]);

  const defaultBusinessId = '6897b362dce30c2c9892b759';

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await dispatch(createContactType({
      userId: currentUserId || '6897acb7f2bc1479c645102d',
      businessId: defaultBusinessId,
      contactTypeName: name.trim(),
      color: color.replace('#',''),
    }));
    setName('');
  };

  /* const handleDelete = (id) => {
    if (!window.confirm('Delete this type?')) return;
    dispatch(deleteContactType(id));
  }; */

  return (
    <div>
      <form className="row g-2 align-items-end mb-3" onSubmit={handleAdd}>
        <div className="col-7">
          <label className="form-label" htmlFor="typeName">Type name</label>
          <input id="typeName" className="form-control" value={name} onChange={(e)=>setName(e.target.value)} placeholder="e.g., Traveler" required />
        </div>
        <div className="col-3">
          <label className="form-label" htmlFor="typeColor">Color</label>
          <input id="typeColor" type="color" className="form-control form-control-color" value={color} onChange={(e)=>setColor(e.target.value)} />
        </div>
        <div className="col-2">
          <button type="submit" className="btn btn-primary w-100" disabled={status==='loading'}>Add</button>
        </div>
      </form>

      <div className="table-responsive">
        <table className="table table-sm align-middle">
          <thead>
            <tr>
              <th style={{width: '36px'}}></th>
              <th>Name</th>
              {/* <th className="text-end" style={{width: '100px'}}>Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {types.map((t)=> (
              <tr key={t._id}>
                <td>
                  <span className="d-inline-block rounded-circle" style={{ width: 16, height:16, backgroundColor: `#${(t.color||'FFFFFF').replace('#','')}`}} />
                </td>
                <td>{t.contactTypeName}</td>
                {/* <td className="text-end">
                  <button className="btn btn-sm btn-outline-danger" onClick={()=>handleDelete(t._id)}>Delete</button>
                </td> */}
              </tr>
            ))}
            {types.length === 0 && (
              <tr><td colSpan={3} className="text-muted">No contact types yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
